import { RequestDataProps } from '@/core/ryanada'

export class DomainRequestData implements RequestDataProps {
  protected name: string
  protected period: number
  protected idProtection: boolean
  protected dnsManagement: boolean
  protected emailForwarding: boolean
  protected token: string

  constructor(
    name: string,
    period: number,
    idProtection: boolean,
    dnsManagement: boolean,
    emailForwarding: boolean,
    token: string
  ) {
    this.name = name
    this.period = period
    this.idProtection = idProtection
    this.dnsManagement = dnsManagement
    this.emailForwarding = emailForwarding
    this.token = token
  }

  public get formData(): FormData {
    throw new Error(
      'DomainRequestData: formData was accessed before i was set. Use DomainAcceptedRequestData instead'
    )
  }
}

export class DomainAcceptedRequestData
  extends DomainRequestData
  implements RequestDataProps
{
  protected i: string
  constructor(
    i: string,
    name: string,
    period: number,
    idProtection: boolean,
    dnsManagement: boolean,
    emailForwarding: boolean,
    token: string
  ) {
    super(name, period, idProtection, dnsManagement, emailForwarding, token)
    this.i = i
  }

  public get formData(): FormData {
    const formData = new FormData()

    formData.append('update', 'true')
    formData.append('domain', this.name)
    formData.append('token', this.token)
    formData.append(`period[${this.i}]`, this.period.toString())
    formData.append('period', this.period.toString())

    if (this.idProtection) {
      formData.append(`idprotection[${this.i}]`, 'on')
    }
    if (this.dnsManagement) {
      formData.append(`dnsmanagement[${this.i}]`, 'on')
    }
    if (this.emailForwarding) {
      formData.append(`emailforwarding[${this.i}]`, 'on')
    }

    return formData
  }
}
